let URL = process.env.API_URL || "https://api.demios.es";

if (process.env.NODE_ENV === 'development') {
  URL = "http://localhost:1337"
}

export default URL;
